<h2 mat-dialog-title>
  {{ viewMode ? "Ver" : editMode ? "Editar" : "Crear" }} Open
</h2>
<mat-dialog-content>
  <form #form class="example-form">
    <!--nombre-->
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Nombre</mat-label>
      <input
        matInput
        [formControl]="name"
        [errorStateMatcher]="matcher"
        maxlength="256"
        placeholder="Ingrese un Nombre para el Open..."
        required
      />
      <mat-hint align="start"><strong></strong></mat-hint>
      <mat-hint align="end">{{ name.value.length }} / 256</mat-hint>
      <mat-error *ngIf="name.hasError('required')"
        >Nombre <strong>requerido</strong></mat-error
      >
    </mat-form-field>
    <!--descripcion-->
    <mat-form-field class="example-full-width" appearance="outline">
      <mat-label>Descripción</mat-label>
      <textarea
        matInput
        [formControl]="description"
        maxlength="800"
        placeholder="Ingrese una Descripción para el Open..."
        cdkTextareaAutosize
        cdkAutosizeMinRows="5"
        cdkAutosizeMaxRows="5"
      ></textarea>
      <mat-hint align="start"><strong></strong></mat-hint>
      <mat-hint align="end">{{ description.value.length }} / 800</mat-hint>
    </mat-form-field>
    <!--fecha inicio propuestas-->
    <mat-form-field appearance="outline">
      <mat-label>Fecha Inicio Propuestas</mat-label>
      <input
        matInput
        [formControl]="allowProposalsFromDate"
        [errorStateMatcher]="matcher"
        [matDatepicker]="pickerAllowProposalsFromDate"
        [readonly]="true"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="pickerAllowProposalsFromDate">
        <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerAllowProposalsFromDate></mat-datepicker>
      <mat-error *ngIf="allowProposalsFromDate.hasError('required')"
        >Fecha <strong>requerida</strong></mat-error
      >
    </mat-form-field>
    &nbsp;
    <!--fecha fin propuestas-->
    <mat-form-field appearance="outline">
      <mat-label>Fecha Fin Propuestas</mat-label>
      <input
        matInput
        [formControl]="allowProposalsUntilDate"
        [errorStateMatcher]="matcher"
        [matDatepicker]="pickerAllowProposalsUntilDate"
        [readonly]="true"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="pickerAllowProposalsUntilDate">
        <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerAllowProposalsUntilDate></mat-datepicker>
      <mat-error *ngIf="allowProposalsUntilDate.hasError('required')"
        >Fecha <strong>requerida</strong></mat-error
      >
    </mat-form-field>
    <!--fecha inicio votacion-->
    <mat-form-field appearance="outline">
      <mat-label>Fecha Inicio Votación</mat-label>
      <input
        matInput
        [formControl]="allowVotingFromDate"
        [errorStateMatcher]="matcher"
        [matDatepicker]="pickerAllowVotingFromDate"
        [readonly]="true"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="pickerAllowVotingFromDate">
        <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerAllowVotingFromDate></mat-datepicker>
      <mat-error *ngIf="allowVotingFromDate.hasError('required')"
        >Fecha <strong>requerida</strong></mat-error
      >
    </mat-form-field>
    &nbsp;
    <!--fecha fin votacion-->
    <mat-form-field appearance="outline">
      <mat-label>Fecha Fin Votación</mat-label>
      <input
        matInput
        [formControl]="allowVotingUntilDate"
        [errorStateMatcher]="matcher"
        [matDatepicker]="pickerAllowVotingUntilDate"
        [readonly]="true"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="pickerAllowVotingUntilDate">
        <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerAllowVotingUntilDate></mat-datepicker>
      <mat-error *ngIf="allowVotingUntilDate.hasError('required')"
        >Fecha <strong>requerida</strong></mat-error
      >
    </mat-form-field>
    &nbsp;
    <!--fecha de realización-->
    <mat-form-field appearance="outline">
      <mat-label>Fecha de Realización</mat-label>
      <input
        matInput
        [formControl]="eventDate"
        [errorStateMatcher]="matcher"
        [matDatepicker]="pickerEventDate"
        [readonly]="true"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="pickerEventDate">
        <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerEventDate></mat-datepicker>
      <mat-error *ngIf="eventDate.hasError('required')"
        >Fecha <strong>requerida</strong></mat-error
      >
    </mat-form-field>
    &nbsp;
    <!--maximo votos-->
    <mat-form-field appearance="outline" style="min-width: 47%">
      <mat-label>Máximo de Votos</mat-label>
      <input
        matInput
        [formControl]="maxVotes"
        [errorStateMatcher]="matcher"
        type="number"
        min="1"
        maxlength="3"
        onkeydown="javascript: return event.keyCode === 8 ||
      event.keyCode === 46 ? true : !isNaN(Number(event.key))"
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        required
      />
      <mat-error *ngIf="maxVotes.hasError('required')"
        >Número <strong>requerido</strong></mat-error
      >
    </mat-form-field>
    <mat-form-field appearance="outline" style="min-width: 47%">
      <mat-label>Templates de Categorias</mat-label>
      <mat-select
        [formControl]="template"
        name="template"
        [errorStateMatcher]="matcher"
        (selectionChange)="changeTemplate(template)"
        required
      >
        <mat-option *ngFor="let template of templates" [value]="template.id">
          {{ template.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <br />
    <!--ocultar votos-->
    <mat-checkbox
      matInput
      [formControl]="showVotes"
      color="primary"
      style="margin-left: 5px"
    >
      <mat-label style="padding-bottom: 15px">Mostrar Total de Votos (Durante el Período de Votación)</mat-label>
    </mat-checkbox>
    <br />
    <!-- Ocultar proponentes -->

    <mat-checkbox
      matInput
      [formControl]="showProposer"
      color="primary"
      style="margin-left: 5px"
    >
      <mat-label style="padding-bottom: 15px">Mostrar proponentes</mat-label>
    </mat-checkbox>
    <br />
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    *ngIf="!viewMode"
    mat-raised-button
    color="primary"
    [disabled]="!formGroup.valid || !formGroup.dirty || disable"
    (click)="openConfirmationDialog()"
  >
    {{ editMode ? "Guardar" : "Crear" }}
  </button>
  <button mat-button color="primary" (click)="onClose()">
    {{ viewMode ? "Cerrar" : "Cancelar" }}
  </button>
</mat-dialog-actions>
